// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==================== RENDER NOTES STYLES ==================== */
.notes-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  /* Header Section */
  /* No Data State */
  /* ==================== TABLE VIEW ==================== */
  /* ==================== GRID VIEW ==================== */
}
.notes-container .notes-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}
.notes-container .notes-header .notes-summary {
  display: flex;
  align-items: center;
  gap: 10px;
}
.notes-container .notes-header .notes-summary p {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
}
.notes-container .notes-header .notes-actions-right {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-left: auto;
}
.notes-container .notes-header .notes-actions-right .view-toggles {
  display: flex;
  gap: 4px;
}
.notes-container .notes-header .notes-actions-right .view-toggles .toggle-btn {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.3rem 0.6rem;
  font-size: 0.85rem;
  font-weight: 500;
  background-color: transparent;
  color: #444;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.notes-container .notes-header .notes-actions-right .view-toggles .toggle-btn svg {
  font-size: 1rem;
  color: inherit;
}
.notes-container .notes-header .notes-actions-right .view-toggles .toggle-btn:hover {
  background-color: #f3f4f6;
}
.notes-container .notes-header .notes-actions-right .view-toggles .toggle-btn.active {
  background-color: #e5e7eb;
  color: #222;
  border-color: #cbd5e1;
}
.notes-container .notes-header .notes-actions-right .add-note-btn button {
  background: var(--primary-color);
  color: white;
  border: none;
  padding: 8px 18px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s;
}
.notes-container .notes-header .notes-actions-right .add-note-btn button:hover {
  background: #0052a3;
}
.notes-container .no-data-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem 1.5rem;
  text-align: center;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border-radius: 16px;
  border: 2px dashed #cbd5e1;
  min-height: 200px;
}
.notes-container .no-data-container .no-data-title {
  font-weight: 600;
  color: #374151;
  margin-bottom: 0.5rem;
}
.notes-container .no-data-container .no-data-message {
  font-size: 1rem;
  color: #6b7280;
  max-width: 400px;
  line-height: 1.5;
}
.notes-container .table-responsive {
  width: 100%;
  overflow-x: auto;
  padding-bottom: 10px;
}
.notes-container .table-responsive::-webkit-scrollbar {
  height: 6px;
}
.notes-container .table-responsive::-webkit-scrollbar-thumb {
  background-color: #cbd5e1;
  border-radius: 4px;
}
.notes-container .documents-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 0.5rem;
  overflow: hidden;
  font-size: 0.95rem;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}
.notes-container .documents-table thead {
  background-color: #f1f5f9;
}
.notes-container .documents-table thead th {
  text-align: left;
  padding: 1rem;
  color: #111827;
  font-weight: 600;
  border-bottom: 1px solid #e2e8f0;
  white-space: nowrap;
  font-size: 14px;
}
.notes-container .documents-table thead th.td-th-casedet {
  font-size: 14px;
}
.notes-container .documents-table tbody tr {
  transition: background-color 0.2s ease;
  cursor: pointer;
}
.notes-container .documents-table tbody tr:hover {
  background-color: #f9fafb;
}
.notes-container .documents-table tbody tr:not(:last-child) td {
  border-bottom: 1px solid #f1f5f9;
}
.notes-container .documents-table tbody tr td {
  padding: 0.9rem 1rem;
  color: #374151;
  vertical-align: middle;
  font-size: 14px;
}
.notes-container .documents-table tbody tr td.td-th-casedet {
  font-size: 14px;
}
.notes-container .documents-table .editdel-table-actions {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
}
.notes-container .documents-table .editdel-table-actions button {
  color: #000;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
  width: 50px;
}
.notes-container .documents-table .editdel-table-actions button.editbtn:hover {
  background: var(--container-bg);
  opacity: 0.9;
}
.notes-container .documents-table .editdel-table-actions button.delbtn:hover {
  background: var(--container-bg);
  opacity: 0.9;
}
.notes-container .notes-grid-layout {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  padding: 10px 2px;
}
.notes-container .notes-grid-layout .modern-note-card {
  background-color: #fff;
  border-radius: 12px;
  border: 1px solid #e0e0e0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: all 0.3s ease;
  height: 100%;
  cursor: pointer;
  /* Header Strip with Actions */
  /* Content Body */
}
.notes-container .notes-grid-layout .modern-note-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.notes-container .notes-grid-layout .modern-note-card .card-header-strip {
  background-color: #f8fafb;
  padding: 12px 14px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-bottom: 2px solid #e2e8f0;
  transition: background 0.3s ease;
  gap: 10px;
}
.notes-container .notes-grid-layout .modern-note-card .card-header-strip .header-left {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  flex: 1 1;
  min-width: 0;
}
.notes-container .notes-grid-layout .modern-note-card .card-header-strip .header-left .note-title-badge {
  font-weight: 700;
  font-size: 0.95rem;
  color: var(--primary-color);
  display: flex;
  align-items: center;
  gap: 8px;
  line-height: 1.4;
}
.notes-container .notes-grid-layout .modern-note-card .card-header-strip .header-left .note-title-badge .type-icon {
  font-size: 1.1rem;
  flex-shrink: 0;
}
.notes-container .notes-grid-layout .modern-note-card .card-header-strip .header-left .note-title-badge .title-text {
  word-break: break-word;
}
.notes-container .notes-grid-layout .modern-note-card .card-header-strip .header-actions {
  display: flex;
  gap: 6px;
  flex-shrink: 0;
  margin-left: auto;
}
.notes-container .notes-grid-layout .modern-note-card .card-header-strip .header-actions .action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
  background-color: white;
  cursor: pointer;
  transition: all 0.2s ease;
}
.notes-container .notes-grid-layout .modern-note-card .card-header-strip .header-actions .action-btn.edit-btn:hover {
  background: var(--container-bg);
  opacity: 0.9;
}
.notes-container .notes-grid-layout .modern-note-card .card-header-strip .header-actions .action-btn.delete-btn:hover {
  background: var(--container-bg);
  opacity: 0.9;
}
.notes-container .notes-grid-layout .modern-note-card .card-content-body {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1 1;
  /* Horizontal Row for Two Items Side by Side */
}
.notes-container .notes-grid-layout .modern-note-card .card-content-body .detail-row-horizontal {
  display: flex;
  gap: 12px;
  width: 100%;
}
.notes-container .notes-grid-layout .modern-note-card .card-content-body .detail-row-horizontal .detail-row-half {
  flex: 1 1;
  min-width: 0;
}
@media (max-width: 480px) {
  .notes-container .notes-grid-layout .modern-note-card .card-content-body .detail-row-horizontal {
    flex-direction: column;
    gap: 8px;
  }
}
.notes-container .notes-grid-layout .modern-note-card .card-content-body .detail-row {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.notes-container .notes-grid-layout .modern-note-card .card-content-body .detail-row .detail-label {
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: #6b7280;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
}
.notes-container .notes-grid-layout .modern-note-card .card-content-body .detail-row .detail-label .row-icon {
  font-size: 0.9rem;
  color: #9ca3af;
}
.notes-container .notes-grid-layout .modern-note-card .card-content-body .detail-row .detail-value {
  font-size: 0.9rem;
  color: #1f2937;
  font-weight: 500;
  padding-left: 2px;
  line-height: 1.5;
  word-break: break-word;
}
.notes-container .notes-grid-layout .modern-note-card .card-content-body .detail-row .detail-value.description-text {
  color: #4b5563;
  max-height: 150px;
  overflow-y: auto;
  padding-right: 4px;
}
.notes-container .notes-grid-layout .modern-note-card .card-content-body .detail-row .detail-value.description-text::-webkit-scrollbar {
  width: 3px;
}
.notes-container .notes-grid-layout .modern-note-card .card-content-body .detail-row .detail-value.description-text::-webkit-scrollbar-thumb {
  background-color: #d1d5db;
  border-radius: 4px;
}
.notes-container .notes-grid-layout .modern-note-card .card-content-body .detail-row .detail-value.description-text .read-more-btn {
  background: none;
  border: none;
  color: var(--primary-color);
  font-weight: 600;
  cursor: pointer;
  font-size: 0.8rem;
  margin-left: 5px;
  padding: 0;
}
.notes-container .notes-grid-layout .modern-note-card .card-content-body .detail-row .detail-value.description-text .read-more-btn:hover {
  text-decoration: underline;
  color: var(--primary-color);
}

/* ==================== RESPONSIVE STYLES ==================== */
@media (max-width: 768px) {
  .notes-container .notes-header {
    flex-direction: column;
    align-items: flex-start;
  }
  .notes-container .notes-header .notes-actions-right {
    margin-left: 0;
    width: 100%;
    justify-content: space-between;
  }
  .notes-container .notes-grid-layout {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  .notes-container .notes-grid-layout .modern-note-card .card-header-strip {
    padding: 12px 16px;
    flex-wrap: wrap;
    gap: 8px;
  }
  .notes-container .notes-grid-layout .modern-note-card .card-header-strip .header-left {
    gap: 10px;
    flex-wrap: wrap;
  }
  .notes-container .notes-grid-layout .modern-note-card .card-header-strip .header-left .note-title-badge {
    font-size: 0.9rem;
  }
  .notes-container .notes-grid-layout .modern-note-card .card-header-strip .header-actions {
    gap: 6px;
  }
  .notes-container .notes-grid-layout .modern-note-card .card-header-strip .header-actions .action-btn {
    width: 30px;
    height: 30px;
  }
  .notes-container .notes-grid-layout .modern-note-card .card-content-body {
    padding: 16px;
    gap: 12px;
  }
  .notes-container .notes-grid-layout .modern-note-card .card-content-body .detail-row-horizontal {
    flex-direction: column;
    gap: 8px;
  }
  .notes-container .notes-grid-layout .modern-note-card .card-content-body .detail-row .detail-value.description-text {
    max-height: 120px;
  }
  .notes-container .documents-table {
    font-size: 0.85rem;
  }
  .notes-container .documents-table thead th,
  .notes-container .documents-table tbody td {
    padding: 0.75rem 0.5rem;
  }
}
@media (max-width: 480px) {
  .notes-container .notes-header .notes-summary {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
  .notes-container .notes-header .notes-actions-right {
    flex-direction: column;
    width: 100%;
  }
  .notes-container .notes-header .notes-actions-right .view-toggles {
    width: 100%;
    justify-content: stretch;
  }
  .notes-container .notes-header .notes-actions-right .view-toggles .toggle-btn {
    flex: 1 1;
  }
  .notes-container .notes-header .notes-actions-right .add-note-btn {
    width: 100%;
  }
  .notes-container .notes-header .notes-actions-right .add-note-btn button {
    width: 100%;
  }
  .notes-container .notes-grid-layout .modern-note-card .card-header-strip {
    padding: 10px 14px;
  }
  .notes-container .notes-grid-layout .modern-note-card .card-header-strip .header-left {
    width: 100%;
    justify-content: space-between;
  }
  .notes-container .notes-grid-layout .modern-note-card .card-header-strip .header-left .note-title-badge {
    font-size: 0.85rem;
  }
  .notes-container .notes-grid-layout .modern-note-card .card-header-strip .header-actions {
    width: 100%;
    justify-content: flex-end;
  }
  .notes-container .notes-grid-layout .modern-note-card .card-content-body .detail-row-horizontal {
    flex-direction: column;
    gap: 8px;
  }
}
/* ==================== INTEGRATION WITH TAB-CONTENT ==================== */
/* These styles ensure proper integration when used within tab-content */
.tab-content .summary.header-actions-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}
.tab-content .summary.header-actions-container .sum-amount {
  display: flex;
  align-items: center;
  gap: 10px;
}
.tab-content .summary.header-actions-container .sum-amount p {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
}
.tab-content .summary.header-actions-container .actions-right {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-left: auto;
}
.tab-content .summary.header-actions-container .actions-right .view-toggles {
  display: flex;
  gap: 4px;
}
.tab-content .summary.header-actions-container .actions-right .view-toggles .toggle-btn {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.3rem 0.6rem;
  font-size: 0.85rem;
  font-weight: 500;
  background-color: transparent;
  color: #444;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.tab-content .summary.header-actions-container .actions-right .view-toggles .toggle-btn svg {
  font-size: 1rem;
  color: inherit;
}
.tab-content .summary.header-actions-container .actions-right .view-toggles .toggle-btn:hover {
  background-color: #f3f4f6;
}
.tab-content .summary.header-actions-container .actions-right .view-toggles .toggle-btn.active {
  background-color: #e5e7eb;
  color: #222;
  border-color: #cbd5e1;
}
.tab-content .summary.header-actions-container .actions-right .tab-add {
  display: flex;
  justify-content: end;
}
.tab-content .summary.header-actions-container .actions-right .tab-add > button {
  background: var(--primary-color);
  color: white;
  border: none;
  padding: 6px 18px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: background-color 0.2s;
}
.tab-content .summary.header-actions-container .actions-right .tab-add > button:hover {
  background: #0052a3;
}
@media (max-width: 600px) {
  .tab-content .summary.header-actions-container {
    flex-direction: column;
    align-items: flex-start !important;
  }
  .tab-content .summary.header-actions-container .actions-right {
    margin-left: 0;
    width: 100%;
    justify-content: space-between;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/TabViewer/style/RenderNotes.scss"],"names":[],"mappings":"AAAA,kEAAA;AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EAEA,mBAAA;EAsFA,kBAAA;EA2BA,yDAAA;EAuGA,wDAAA;AAtNF;AADE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;AAGJ;AADI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAGN;AADM;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAGR;AAKI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;AAHN;AAKM;EACE,aAAA;EACA,QAAA;AAHR;AAKQ;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6BAAA;EACA,WAAA;EACA,qCAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;AAHV;AAKU;EACE,eAAA;EACA,cAAA;AAHZ;AAMU;EACE,yBAAA;AAJZ;AAOU;EACE,yBAAA;EACA,WAAA;EACA,qBAAA;AALZ;AAWQ;EACE,gCAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,iCAAA;AATV;AAWU;EACE,mBAAA;AATZ;AAiBE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;EACA,6DAAA;EACA,mBAAA;EACA,0BAAA;EACA,iBAAA;AAfJ;AAiBI;EACE,gBAAA;EACA,cAAA;EACA,qBAAA;AAfN;AAkBI;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AAhBN;AAqBE;EACE,WAAA;EACA,gBAAA;EACA,oBAAA;AAnBJ;AAqBI;EACE,WAAA;AAnBN;AAqBI;EACE,yBAAA;EACA,kBAAA;AAnBN;AAuBE;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yCAAA;AArBJ;AAuBI;EACE,yBAAA;AArBN;AAuBM;EACE,gBAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,gCAAA;EACA,mBAAA;EACA,eAAA;AArBR;AAuBQ;EACE,eAAA;AArBV;AA2BM;EACE,sCAAA;EACA,eAAA;AAzBR;AA2BQ;EACE,yBAAA;AAzBV;AA4BQ;EACE,gCAAA;AA1BV;AA6BQ;EACE,oBAAA;EACA,cAAA;EACA,sBAAA;EACA,eAAA;AA3BV;AA6BU;EACE,eAAA;AA3BZ;AAiCI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;AA/BN;AAiCM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,6CAAA;EACA,WAAA;AA/BR;AAkCU;EACE,+BAAA;EACA,YAAA;AAhCZ;AAqCU;EACE,+BAAA;EACA,YAAA;AAnCZ;AA2CE;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EACA,iBAAA;AAzCJ;AA2CI;EACE,sBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yCAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EAOA,8BAAA;EA0EA,iBAAA;AAxHN;AAyCM;EACE,2BAAA;EACA,yCAAA;AAvCR;AA2CM;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,gCAAA;EACA,gCAAA;EACA,SAAA;AAzCR;AA2CQ;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;AAzCV;AA2CU;EACE,gBAAA;EACA,kBAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AAzCZ;AA2CY;EACE,iBAAA;EACA,cAAA;AAzCd;AA4CY;EACE,sBAAA;AA1Cd;AA+CQ;EACE,aAAA;EACA,QAAA;EACA,cAAA;EACA,iBAAA;AA7CV;AA+CU;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;AA7CZ;AAgDc;EACE,+BAAA;EACA,YAAA;AA9ChB;AAmDc;EACE,+BAAA;EACA,YAAA;AAjDhB;AAyDM;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,SAAA;EAEA,8CAAA;AAxDR;AAyDQ;EACE,aAAA;EACA,SAAA;EACA,WAAA;AAvDV;AAyDU;EACE,SAAA;EACA,YAAA;AAvDZ;AA0DU;EAVF;IAWI,sBAAA;IACA,QAAA;EAvDV;AACF;AA0DQ;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAxDV;AA0DU;EACE,iBAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAxDZ;AA0DY;EACE,iBAAA;EACA,cAAA;AAxDd;AA4DU;EACE,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;AA1DZ;AA4DY;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AA1Dd;AA4Dc;EACE,UAAA;AA1DhB;AA4Dc;EACE,yBAAA;EACA,kBAAA;AA1DhB;AA6Dc;EACE,gBAAA;EACA,YAAA;EACA,2BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,UAAA;AA3DhB;AA6DgB;EACE,0BAAA;EACA,2BAAA;AA3DlB;;AAsEA,gEAAA;AACA;EAEI;IACE,sBAAA;IACA,uBAAA;EApEJ;EAsEI;IACE,cAAA;IACA,WAAA;IACA,8BAAA;EApEN;EAwEE;IACE,0BAAA;IACA,SAAA;EAtEJ;EAyEM;IACE,kBAAA;IACA,eAAA;IACA,QAAA;EAvER;EAyEQ;IACE,SAAA;IACA,eAAA;EAvEV;EAyEU;IACE,iBAAA;EAvEZ;EA2EQ;IACE,QAAA;EAzEV;EA2EU;IACE,WAAA;IACA,YAAA;EAzEZ;EA8EM;IACE,aAAA;IACA,SAAA;EA5ER;EA8EQ;IACE,sBAAA;IACA,QAAA;EA5EV;EAgFU;IACE,iBAAA;EA9EZ;EAqFE;IACE,kBAAA;EAnFJ;EAqFI;;IAEE,uBAAA;EAnFN;AACF;AAwFA;EAGM;IACE,sBAAA;IACA,uBAAA;IACA,QAAA;EAxFN;EA2FI;IACE,sBAAA;IACA,WAAA;EAzFN;EA2FM;IACE,WAAA;IACA,wBAAA;EAzFR;EA2FQ;IACE,SAAA;EAzFV;EA6FM;IACE,WAAA;EA3FR;EA6FQ;IACE,WAAA;EA3FV;EAmGM;IACE,kBAAA;EAjGR;EAmGQ;IACE,WAAA;IACA,8BAAA;EAjGV;EAmGU;IACE,kBAAA;EAjGZ;EAqGQ;IACE,WAAA;IACA,yBAAA;EAnGV;EAwGQ;IACE,sBAAA;IACA,QAAA;EAtGV;AACF;AA6GA,2EAAA;AACA,wEAAA;AAEE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;AA5GJ;AA8GI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AA5GN;AA8GM;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA5GR;AAgHI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;AA9GN;AAgHM;EACE,aAAA;EACA,QAAA;AA9GR;AAgHQ;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6BAAA;EACA,WAAA;EACA,qCAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;AA9GV;AAgHU;EACE,eAAA;EACA,cAAA;AA9GZ;AAiHU;EACE,yBAAA;AA/GZ;AAkHU;EACE,yBAAA;EACA,WAAA;EACA,qBAAA;AAhHZ;AAqHM;EACE,aAAA;EACA,oBAAA;AAnHR;AAqHQ;EACE,gCAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,iCAAA;AAnHV;AAqHU;EACE,mBAAA;AAnHZ;AA0HE;EACE;IACE,sBAAA;IACA,kCAAA;EAxHJ;EA0HI;IACE,cAAA;IACA,WAAA;IACA,8BAAA;EAxHN;AACF","sourcesContent":["/* ==================== RENDER NOTES STYLES ==================== */\r\n\r\n.notes-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n\r\n  /* Header Section */\r\n  .notes-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    flex-wrap: wrap;\r\n    gap: 16px;\r\n\r\n    .notes-summary {\r\n      display: flex;\r\n      align-items: center;\r\n      gap: 10px;\r\n\r\n      p {\r\n        margin: 0;\r\n        font-size: 14px;\r\n        font-weight: 600;\r\n        color: #374151;\r\n\r\n        &.note-count {\r\n          // Additional styles if needed\r\n        }\r\n      }\r\n    }\r\n\r\n    .notes-actions-right {\r\n      display: flex;\r\n      align-items: center;\r\n      gap: 16px;\r\n      margin-left: auto;\r\n\r\n      .view-toggles {\r\n        display: flex;\r\n        gap: 4px;\r\n\r\n        .toggle-btn {\r\n          display: flex;\r\n          align-items: center;\r\n          gap: 0.3rem;\r\n          padding: 0.3rem 0.6rem;\r\n          font-size: 0.85rem;\r\n          font-weight: 500;\r\n          background-color: transparent;\r\n          color: #444;\r\n          border: 1px solid var(--border-color);\r\n          border-radius: 6px;\r\n          cursor: pointer;\r\n          transition: all 0.2s ease;\r\n\r\n          svg {\r\n            font-size: 1rem;\r\n            color: inherit;\r\n          }\r\n\r\n          &:hover {\r\n            background-color: #f3f4f6;\r\n          }\r\n\r\n          &.active {\r\n            background-color: #e5e7eb;\r\n            color: #222;\r\n            border-color: #cbd5e1;\r\n          }\r\n        }\r\n      }\r\n\r\n      .add-note-btn {\r\n        button {\r\n          background: var(--primary-color);\r\n          color: white;\r\n          border: none;\r\n          padding: 8px 18px;\r\n          border-radius: 6px;\r\n          cursor: pointer;\r\n          font-size: 14px;\r\n          font-weight: 500;\r\n          transition: background-color 0.2s;\r\n\r\n          &:hover {\r\n            background: #0052a3;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  /* No Data State */\r\n  .no-data-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 1rem 1.5rem;\r\n    text-align: center;\r\n    background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\r\n    border-radius: 16px;\r\n    border: 2px dashed #cbd5e1;\r\n    min-height: 200px;\r\n\r\n    .no-data-title {\r\n      font-weight: 600;\r\n      color: #374151;\r\n      margin-bottom: 0.5rem;\r\n    }\r\n\r\n    .no-data-message {\r\n      font-size: 1rem;\r\n      color: #6b7280;\r\n      max-width: 400px;\r\n      line-height: 1.5;\r\n    }\r\n  }\r\n\r\n  /* ==================== TABLE VIEW ==================== */\r\n  .table-responsive {\r\n    width: 100%;\r\n    overflow-x: auto;\r\n    padding-bottom: 10px;\r\n\r\n    &::-webkit-scrollbar {\r\n      height: 6px;\r\n    }\r\n    &::-webkit-scrollbar-thumb {\r\n      background-color: #cbd5e1;\r\n      border-radius: 4px;\r\n    }\r\n  }\r\n\r\n  .documents-table {\r\n    width: 100%;\r\n    border-collapse: separate;\r\n    border-spacing: 0;\r\n    background-color: #ffffff;\r\n    border: 1px solid #e2e8f0;\r\n    border-radius: 0.5rem;\r\n    overflow: hidden;\r\n    font-size: 0.95rem;\r\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\r\n\r\n    thead {\r\n      background-color: #f1f5f9;\r\n\r\n      th {\r\n        text-align: left;\r\n        padding: 1rem;\r\n        color: #111827;\r\n        font-weight: 600;\r\n        border-bottom: 1px solid #e2e8f0;\r\n        white-space: nowrap;\r\n        font-size: 14px;\r\n\r\n        &.td-th-casedet {\r\n          font-size: 14px;\r\n        }\r\n      }\r\n    }\r\n\r\n    tbody {\r\n      tr {\r\n        transition: background-color 0.2s ease;\r\n        cursor: pointer;\r\n\r\n        &:hover {\r\n          background-color: #f9fafb;\r\n        }\r\n\r\n        &:not(:last-child) td {\r\n          border-bottom: 1px solid #f1f5f9;\r\n        }\r\n\r\n        td {\r\n          padding: 0.9rem 1rem;\r\n          color: #374151;\r\n          vertical-align: middle;\r\n          font-size: 14px;\r\n\r\n          &.td-th-casedet {\r\n            font-size: 14px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .editdel-table-actions {\r\n      display: flex;\r\n      justify-content: center;\r\n      align-items: center;\r\n      gap: 8px;\r\n\r\n      button {\r\n        color: #000;\r\n        border: none;\r\n        padding: 8px 16px;\r\n        border-radius: 6px;\r\n        font-weight: 500;\r\n        cursor: pointer;\r\n        transition: background-color 0.2s ease-in-out;\r\n        width: 50px;\r\n\r\n        &.editbtn {\r\n          &:hover {\r\n            background: var(--container-bg);\r\n            opacity: 0.9;\r\n          }\r\n        }\r\n\r\n        &.delbtn {\r\n          &:hover {\r\n            background: var(--container-bg);\r\n            opacity: 0.9;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  /* ==================== GRID VIEW ==================== */\r\n  .notes-grid-layout {\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\r\n    gap: 20px;\r\n    padding: 10px 2px;\r\n\r\n    .modern-note-card {\r\n      background-color: #fff;\r\n      border-radius: 12px;\r\n      border: 1px solid #e0e0e0;\r\n      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\r\n      display: flex;\r\n      flex-direction: column;\r\n      overflow: hidden;\r\n      transition: all 0.3s ease;\r\n      height: 100%;\r\n      cursor: pointer;\r\n\r\n      &:hover {\r\n        transform: translateY(-2px);\r\n        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\r\n      }\r\n\r\n      /* Header Strip with Actions */\r\n      .card-header-strip {\r\n        background-color: #f8fafb;\r\n        padding: 12px 14px;\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: flex-start;\r\n        border-bottom: 2px solid #e2e8f0;\r\n        transition: background 0.3s ease;\r\n        gap: 10px;\r\n\r\n        .header-left {\r\n          display: flex;\r\n          align-items: center;\r\n          flex-wrap: wrap;\r\n          gap: 8px;\r\n          flex: 1;\r\n          min-width: 0;\r\n\r\n          .note-title-badge {\r\n            font-weight: 700;\r\n            font-size: 0.95rem;\r\n            color: var(--primary-color);\r\n            display: flex;\r\n            align-items: center;\r\n            gap: 8px;\r\n            line-height: 1.4;\r\n\r\n            .type-icon {\r\n              font-size: 1.1rem;\r\n              flex-shrink: 0;\r\n            }\r\n\r\n            .title-text {\r\n              word-break: break-word;\r\n            }\r\n          }\r\n        }\r\n\r\n        .header-actions {\r\n          display: flex;\r\n          gap: 6px;\r\n          flex-shrink: 0;\r\n          margin-left: auto;\r\n\r\n          .action-btn {\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n            width: 32px;\r\n            height: 32px;\r\n            border-radius: 6px;\r\n            border: 1px solid #e5e7eb;\r\n            background-color: white;\r\n            cursor: pointer;\r\n            transition: all 0.2s ease;\r\n\r\n            &.edit-btn {\r\n              &:hover {\r\n                background: var(--container-bg);\r\n                opacity: 0.9;\r\n              }\r\n            }\r\n\r\n            &.delete-btn {\r\n              &:hover {\r\n                background: var(--container-bg);\r\n                opacity: 0.9;\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n\r\n      /* Content Body */\r\n      .card-content-body {\r\n        padding: 16px;\r\n        display: flex;\r\n        flex-direction: column;\r\n        gap: 12px;\r\n        flex: 1;\r\n\r\n        /* Horizontal Row for Two Items Side by Side */\r\n        .detail-row-horizontal {\r\n          display: flex;\r\n          gap: 12px;\r\n          width: 100%;\r\n\r\n          .detail-row-half {\r\n            flex: 1;\r\n            min-width: 0;\r\n          }\r\n\r\n          @media (max-width: 480px) {\r\n            flex-direction: column;\r\n            gap: 8px;\r\n          }\r\n        }\r\n\r\n        .detail-row {\r\n          display: flex;\r\n          flex-direction: column;\r\n          gap: 4px;\r\n\r\n          .detail-label {\r\n            font-size: 0.7rem;\r\n            text-transform: uppercase;\r\n            letter-spacing: 0.6px;\r\n            color: #6b7280;\r\n            font-weight: 600;\r\n            display: flex;\r\n            align-items: center;\r\n            gap: 6px;\r\n\r\n            .row-icon {\r\n              font-size: 0.9rem;\r\n              color: #9ca3af;\r\n            }\r\n          }\r\n\r\n          .detail-value {\r\n            font-size: 0.9rem;\r\n            color: #1f2937;\r\n            font-weight: 500;\r\n            padding-left: 2px;\r\n            line-height: 1.5;\r\n            word-break: break-word;\r\n\r\n            &.description-text {\r\n              color: #4b5563;\r\n              max-height: 150px;\r\n              overflow-y: auto;\r\n              padding-right: 4px;\r\n\r\n              &::-webkit-scrollbar {\r\n                width: 3px;\r\n              }\r\n              &::-webkit-scrollbar-thumb {\r\n                background-color: #d1d5db;\r\n                border-radius: 4px;\r\n              }\r\n\r\n              .read-more-btn {\r\n                background: none;\r\n                border: none;\r\n                color: var(--primary-color);\r\n                font-weight: 600;\r\n                cursor: pointer;\r\n                font-size: 0.8rem;\r\n                margin-left: 5px;\r\n                padding: 0;\r\n\r\n                &:hover {\r\n                  text-decoration: underline;\r\n                  color: var(--primary-color);\r\n                }\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n/* ==================== RESPONSIVE STYLES ==================== */\r\n@media (max-width: 768px) {\r\n  .notes-container {\r\n    .notes-header {\r\n      flex-direction: column;\r\n      align-items: flex-start;\r\n\r\n      .notes-actions-right {\r\n        margin-left: 0;\r\n        width: 100%;\r\n        justify-content: space-between;\r\n      }\r\n    }\r\n\r\n    .notes-grid-layout {\r\n      grid-template-columns: 1fr;\r\n      gap: 16px;\r\n\r\n      .modern-note-card {\r\n        .card-header-strip {\r\n          padding: 12px 16px;\r\n          flex-wrap: wrap;\r\n          gap: 8px;\r\n\r\n          .header-left {\r\n            gap: 10px;\r\n            flex-wrap: wrap;\r\n\r\n            .note-title-badge {\r\n              font-size: 0.9rem;\r\n            }\r\n          }\r\n\r\n          .header-actions {\r\n            gap: 6px;\r\n\r\n            .action-btn {\r\n              width: 30px;\r\n              height: 30px;\r\n            }\r\n          }\r\n        }\r\n\r\n        .card-content-body {\r\n          padding: 16px;\r\n          gap: 12px;\r\n\r\n          .detail-row-horizontal {\r\n            flex-direction: column;\r\n            gap: 8px;\r\n          }\r\n\r\n          .detail-row {\r\n            .detail-value.description-text {\r\n              max-height: 120px;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .documents-table {\r\n      font-size: 0.85rem;\r\n\r\n      thead th,\r\n      tbody td {\r\n        padding: 0.75rem 0.5rem;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .notes-container {\r\n    .notes-header {\r\n      .notes-summary {\r\n        flex-direction: column;\r\n        align-items: flex-start;\r\n        gap: 4px;\r\n      }\r\n\r\n      .notes-actions-right {\r\n        flex-direction: column;\r\n        width: 100%;\r\n\r\n        .view-toggles {\r\n          width: 100%;\r\n          justify-content: stretch;\r\n\r\n          .toggle-btn {\r\n            flex: 1;\r\n          }\r\n        }\r\n\r\n        .add-note-btn {\r\n          width: 100%;\r\n\r\n          button {\r\n            width: 100%;\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .notes-grid-layout {\r\n      .modern-note-card {\r\n        .card-header-strip {\r\n          padding: 10px 14px;\r\n\r\n          .header-left {\r\n            width: 100%;\r\n            justify-content: space-between;\r\n\r\n            .note-title-badge {\r\n              font-size: 0.85rem;\r\n            }\r\n          }\r\n\r\n          .header-actions {\r\n            width: 100%;\r\n            justify-content: flex-end;\r\n          }\r\n        }\r\n\r\n        .card-content-body {\r\n          .detail-row-horizontal {\r\n            flex-direction: column;\r\n            gap: 8px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n/* ==================== INTEGRATION WITH TAB-CONTENT ==================== */\r\n/* These styles ensure proper integration when used within tab-content */\r\n.tab-content {\r\n  .summary.header-actions-container {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    flex-wrap: wrap;\r\n    gap: 16px;\r\n\r\n    .sum-amount {\r\n      display: flex;\r\n      align-items: center;\r\n      gap: 10px;\r\n\r\n      p {\r\n        margin: 0;\r\n        font-size: 14px;\r\n        font-weight: 600;\r\n        color: #374151;\r\n      }\r\n    }\r\n\r\n    .actions-right {\r\n      display: flex;\r\n      align-items: center;\r\n      gap: 16px;\r\n      margin-left: auto;\r\n\r\n      .view-toggles {\r\n        display: flex;\r\n        gap: 4px;\r\n\r\n        .toggle-btn {\r\n          display: flex;\r\n          align-items: center;\r\n          gap: 0.3rem;\r\n          padding: 0.3rem 0.6rem;\r\n          font-size: 0.85rem;\r\n          font-weight: 500;\r\n          background-color: transparent;\r\n          color: #444;\r\n          border: 1px solid var(--border-color);\r\n          border-radius: 6px;\r\n          cursor: pointer;\r\n          transition: all 0.2s ease;\r\n\r\n          svg {\r\n            font-size: 1rem;\r\n            color: inherit;\r\n          }\r\n\r\n          &:hover {\r\n            background-color: #f3f4f6;\r\n          }\r\n\r\n          &.active {\r\n            background-color: #e5e7eb;\r\n            color: #222;\r\n            border-color: #cbd5e1;\r\n          }\r\n        }\r\n      }\r\n\r\n      .tab-add {\r\n        display: flex;\r\n        justify-content: end;\r\n\r\n        > button {\r\n          background: var(--primary-color);\r\n          color: white;\r\n          border: none;\r\n          padding: 6px 18px;\r\n          border-radius: 6px;\r\n          cursor: pointer;\r\n          font-size: 13px;\r\n          font-weight: 500;\r\n          transition: background-color 0.2s;\r\n\r\n          &:hover {\r\n            background: #0052a3;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  @media (max-width: 600px) {\r\n    .summary.header-actions-container {\r\n      flex-direction: column;\r\n      align-items: flex-start !important;\r\n\r\n      .actions-right {\r\n        margin-left: 0;\r\n        width: 100%;\r\n        justify-content: space-between;\r\n      }\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
